import { BrowserUtils, InteractionType } from '@azure/msal-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

export async function handleMsalRedirectBridge(): Promise<boolean> {
    let interactionType: string;
    try {
        interactionType = BrowserUtils.parseAuthResponseFromUrl().libraryState.meta['interactionType'];
    } catch {
        return false;
    }

    // Only handle silent and popup interactions through the redirect bridge
    if (interactionType !== InteractionType.Silent && interactionType !== InteractionType.Popup) {
        return false;
    }

    // Broadcast the response to the main frame and prevent further handling by the application
    await broadcastResponseToMainFrame();
    return true;
}
